import React from "react";
import { CHEVRON_LEFT_ICON } from "../../utils/svgs_new";
import { AppIcon } from "../Generic/AppIcon";

interface Props {
  onClick?: () => void;
}

const BackButton = (props: Props) => {
  return (
    <div onClick={props.onClick} className="BackButton">
      <AppIcon icon={CHEVRON_LEFT_ICON} size={10} />
    </div>
  );
};

export default BackButton;
